import { COMBAT_TUNING } from "../../../data/tuning.js";
import { MAX_JUMPS } from "../../../constants.js";
import { tryUsePortal } from "../map/sceneSetup.js";

function scaleDamping(basePerFrame, dtScale) {
  return Math.pow(basePerFrame, dtScale);
}

export function applyPlayerMovement(scene, { dt, dtScale, keys, aabbOverlap, enableDebugHitboxToggle }) {
  const p = scene.playerEntity;
  if (!p || !aabbOverlap) return false;

  // Player knockback (horizontal only)
  if (p.hitStopTimer <= 0 && p.knockbackVx !== 0) {
    p.vx = p.knockbackVx;
    p.knockbackVx *= scaleDamping(COMBAT_TUNING.knockbackDecayX, dtScale);
    if (Math.abs(p.knockbackVx) < 0.1) p.knockbackVx = 0;
  }

  // Debug hurt
  if (keys.h && !scene.prevKeys.hurt) p.takeDamage(20, 0, "pve");
  scene.prevKeys.hurt = keys.h;
  if (enableDebugHitboxToggle) {
    if (keys.t && !scene.prevKeys.debug) scene.showDebugHitboxes = !scene.showDebugHitboxes;
    scene.prevKeys.debug = keys.t;
  } else {
    scene.showDebugHitboxes = false;
    scene.prevKeys.debug = false;
  }

  if (scene.playerSprite.anims.isPaused) scene.playerSprite.anims.resume();

  // Player input + physics
  p.processInput(keys, scene.prevKeys, dt, dtScale);
  p.applyGravity(dtScale);
  const preSlideY = p.y;
  scene.resolveEntityCollisions(p, dtScale);

  // Slope affects slide speed
  if (p.sliding && p.onGround) {
    const dy = p.y - preSlideY;
    if (dy < -1) {
      // Uphill — extra deceleration
      p.vx *= scaleDamping(0.92, dtScale);
    } else if (dy > 1) {
      // Downhill — reduce friction significantly
      p.vx *= Math.pow(1.03, dtScale);
    }
  }

  // Step off ladder at bottom
  if (p.onLadder && p.onGround && keys.down) p.onLadder = false;

  // Reset jumps on ground/ladder
  if (p.onGround || p.onLadder) p.jumpsLeft = MAX_JUMPS;

  const overlappingPortal = scene.portalZones.some((zone) => aabbOverlap(p.getBounds(), zone));
  scene.ui?.setInteractTextVisible(overlappingPortal && !p.dead && !p.dying);

  return tryUsePortal(scene, p, keys, { aabbOverlap });
}
